<template>
  <div class="location-dialog">
    <el-dialog
      v-drag
      :modal="false"
      title="位置搜索"
      width="500px"
      :visible="visible"
      :before-close="beforeClose"
    >
      <div class="tab-box">
        <div class="tab-title">
          <div
            v-for="item in searchTabList"
            :key="item.type"
            @click="activeTab = item.type"
            :class="[
              'tab-item',
              {
                'is-active': item.type === activeTab
              }
            ]"
          >
            {{ item.name || '' }}
          </div>
        </div>
        <div class="tabContent">
          <div v-if="activeTab === 'location'" class="first-tab">
            <el-autocomplete
              v-model="address"
              :fetch-suggestions="querySearch"
              placeholder="请输入地址"
              popper-class="location-pop"
            ></el-autocomplete>
            <!-- <input
              v-model="address"
              class="clean-input w-100 input"
              type="text"
              placeholder="请输入地址"
            /> -->
          </div>
          <div class="sec-tab" v-if="activeTab === 'area' && showArea">
            <el-cascader
              popper-class="custome-popper-class"
              :props="props"
              v-model="place"
              :options="regionList"
              filterable
              @change="handleChange"
            ></el-cascader>
          </div>
          <div class="third-tab" v-if="activeTab === 'latlng'">
            <el-input v-model="lat" placeholder="请输入纬度"></el-input>
            <el-input v-model="lon" placeholder="请输入经度"></el-input>
            <!-- <input
              v-model.number="lat"
              class="clean-input w-100 input"
              type="text"
              placeholder="请输入纬度"
            /> -->
          </div>
        </div>
      </div>

      <div slot="footer" class="wind-stand-footer flex-reverse">
        <div class="btn-wrapper">
          <el-button
            v-if="activeTab === 'location'"
            type="text"
            @click="handleSearchClick"
            >搜索</el-button
          >
          <template v-if="activeTab === 'area'">
            <el-button type="text" @click="handleClearClick">清除</el-button>
            <el-button type="text" @click="handleCreateClick"
              >创建区域</el-button
            >
          </template>
          <template v-if="activeTab === 'latlng'">
            <el-button type="text" @click="handleClearClick">清除</el-button>
            <el-button type="text" @click="handleENClick">定位</el-button>
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const KEY = '06a7b2a0002253e5da6a91e5cfd36334';
import axios from 'axios';
import { mapGetters, mapState } from 'vuex';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function,
      default: () => {}
    },
    showArea: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapState(['rawRegionList']),
    ...mapGetters(['regionList']),
    searchTabList() {
      const tabs = [
        {
          name: '经纬度定位',
          type: 'latlng'
        }
      ];

      tabs.push({
        name: '位置搜索',
        type: 'location'
      });

      if (this.showArea) {
        tabs.push({
          name: '区域定位',
          type: 'area'
        });
      }
      return tabs;
    }
  },
  data() {
    return {
      activeTab: 'latlng',
      address: '',
      place: [],
      lat: '',
      lon: '',
      options: [],
      locationList: [],
      props: {
        label: 'regionName',
        value: 'com',
        children: 'children',
        checkStrictly: false
      },
      suggestions: []
    };
  },
  methods: {
    // handleCompSelect() {
    //   this.handleSearchClick();
    // },
    querySearch(queryString, cb) {
      if (!queryString) cb([]);
      axios
        .get('https://restapi.amap.com/v3/place/text', {
          params: {
            key: KEY,
            keywords: queryString.trim()
          }
        })
        .then(res => {
          const { pois = [] } = res.data;
          const arr = pois.map(i => {
            return {
              value: i.name
            };
          });
          cb(arr);
        });
    },
    handleChange() {
      ('');
    },
    handleSearchClick() {
      if (!this.address) {
        return this.$message.warning('搜索位置不能为空');
      }

      axios
        .get('https://restapi.amap.com/v3/geocode/geo', {
          params: {
            key: KEY,
            address: this.address
          }
        })
        .then(res => {
          const { geocodes = [] } = res.data;

          if (!geocodes.length) {
            return this.$message.error('没有找到该地址');
          }
          const { location } = geocodes[0];

          const arr = location.split(',');
          this.$emit('addressSearch', {
            address: {
              lng: +arr[0],
              lat: +arr[1]
            },
            name: this.address
          });
        })
        .catch(() => {
          this.$message.error('服务暂不可用');
        });
    },
    handleCreateClick() {
      const placeArr = this.place
        .map(i => i.split(','))
        .map(i => ({ code: i[0], name: i[1] }));

      const length = placeArr.length;
      if (!length) return this.$message.warning('请选择区域');

      this.$emit('createArea', {
        adcode: +placeArr[length - 1].code,
        polyline: null,
        name: placeArr.reduce((acc, c) => {
          acc += c.name;
          return acc;
        }, ''),
        code: +placeArr[length - 1].code
      });

      // axios
      //   .get('https://restapi.amap.com/v3/config/district', {
      //     params: {
      //       key: KEY,
      //       subdistrict: 0,
      //       keywords: placeArr[length - 1].code,
      //       extensions: 'all'
      //     }
      //   })
      //   .then(res => {
      //     const { data } = res;

      //     const { districts = [] } = data;
      //     const { polyline = '', adcode = '' } = districts[0] || {};

      //     const polylineArr = polyline
      //       .replace(/\|/g, ',')
      //       .split(';')
      //       .map(i =>
      //         i.split(',').map(i => {
      //           return +i;
      //         })
      //       );

      //   })
      //   .catch(() => {
      //     this.$message.error('服务暂不可用');
      //   });

      // this.$emit('createArea', this.place[2] || '');
    },
    handleENClick() {
      if (!this.lat || !this.lon) {
        return this.$message.warning('请输入经纬度');
      }

      if (+this.lon >= 180 || +this.lon <= -180) {
        return this.$message.warning('经度范围应在-180°至180°之间');
      }

      if (+this.lat >= 90 || +this.lat <= -90) {
        return this.$message.warning('纬度范围应在-90°至90°之间');
      }

      this.$emit('latAndLon', {
        lat: +this.lat,
        lng: +this.lon
      });
    },
    handleClearClick() {
      this.place = '';
      this.position = '';
      this.address = '';
      this.lon = '';
      this.lat = '';
    }
  },

  mounted() {
    this.$store.dispatch('getRegionList');
  }
};
</script>

<style lang="less" scoped>
.input {
  margin-top: 10px;
}
.tabContent {
  height: 200px;
}
.location-dialog {
  width: 500px;
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;

  .tab-box {
    box-sizing: border-box;

    .tab-title {
      width: 100%;
      display: flex;

      .tab-item {
        flex: 1;
        box-sizing: border-box;
        height: 30px;
        line-height: 28px;
        text-align: center;
        border: 1px solid #000;
        // padding: 5px 10px;
        border-right: none;
        cursor: pointer;
        &:last-child {
          border: 1px solid #000;
        }
        &.is-active {
          background-color: #0876bd;
          color: #fff;
        }
      }
    }
  }

  .el-dialog__wrapper {
    top: unset;
    left: unset;
    right: unset;
    bottom: unset;
    margin: 0 !important;

    /deep/.el-dialog {
      margin: 0 !important;
    }
  }
}

.third-tab,
.first-tab,
.sec-tab {
  & > div {
    margin-top: 10px;
  }
}
</style>

<style lang="less">
.first-tab {
  // margin-top: 10px;
  .el-autocomplete {
    width: 100%;
  }
}
.sec-tab {
  .el-cascader {
    width: 100%;
  }
}
</style>
